// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"f06d32ea","453":"f0d5fce9","537":"378f4291"}[chunkId] + ".chunk.js";
};